import { PAYMENT_API_RESPONSE_SEND } from '../constants/premiumSubscriptionTypes';

export function paymentApiResponseSend(parameters) {
  return {
    type: PAYMENT_API_RESPONSE_SEND,
    payload: parameters
  };
}



// WEBPACK FOOTER //
// ./app/actions/premiumSubscriptionActions.js